/**
 * Represents a dropdown accordion
 *
 * Uses Custom Element <klaviyo-form>
 *
 * @constructor
 * @param {HTMLElement} container parent custom element
 */

export class KlaviyoForm {
  constructor(container) {
    this.container = container;
    this.form = this.container.querySelector("form");
    this.klaviyoListId = this.container.getAttribute("data-klaviyo-list-id");
    this.email = this.container.querySelector('input[type="email"]');
    this.phone = this.container.querySelector('input[type="tel"]');
    this.companyId = "PbvgDc";

    if (this.phone) {
      this.phone.addEventListener('input', this.onPhoneInput)
      this.phone.addEventListener("keydown", function (e) {
        if ((e.key === "Backspace" || e.key === "Delete") && this.value === "+1") {
          this.value = "";
        }
      });
      this.phone.addEventListener("focus", function () {
        if (!this.value.startsWith("+1")) {
          this.value = "+1" + this.value.replace(/^\+?[0-9]*/, "");
        }
      });
      this.phone.addEventListener("blur", function () {
        if (this.value === "+1") {
          this.value = "";
        }
      });
    }

    if (this.klaviyoListId) {
      this.form.addEventListener("submit", this.sendForm.bind(this));
    } else {
      return console.error("Klaviyo form id not found.");
    }
  }

  formData() {
    return {
      method: "POST",
      headers: { revision: "2024-02-15", "content-type": "application/json" },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            custom_source:
              this.container.querySelector('[name="contact[tags]"]')?.value ||
              "Signup form",
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: this.email?.value || null,
                  phone_number: this.phone?.value || null,
                },
              },
            },
          },
          relationships: {
            list: { data: { type: "list", id: this.klaviyoListId } },
          },
        },
      }),
    };
  }

  showMessage(type) {
    this.email?.classList.add(type);
    this.phone?.classList.add(type);
    this.container
      .querySelectorAll(".klaviyo-form__message")
      .forEach((message) => message.classList.add("hide"));
    this.container
      .querySelector(".klaviyo-form__" + type)
      ?.classList.remove("hide");

    if (type === "success" && this.email) {
      this.container
        .querySelector(".klaviyo-form__wrapper")
        ?.classList.add("hide");
    }

    setTimeout(() => {
      this.email?.classList.remove(type);
      this.phone?.classList.add(type);
      this.container
        .querySelector(".klaviyo-form__" + type)
        ?.classList.add("hide");
      this.container
        .querySelector(".klaviyo-form__wrapper")
        ?.classList.remove("hide");
    }, 7000);
  }

  sendForm(event) {
    event.preventDefault();
    const _this = this;

    if (this.emailValidation() && this.phoneValidation()) {
      fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${this.companyId}`,
        this.formData()
      )
        .then((response) => {
          response.status === 202
            ? _this.showMessage("success")
            : _this.showMessage("error");
        })
        .catch((err) => {
          console.error(err);
          _this.showMessage("error");
        });
    } else {
      let errorType = "error-email";

      if (!this.phoneValidation() && this.emailValidation())
        errorType = "error-phone";

      console.log(errorType);
      this.showMessage(errorType);
    }
  }

  emailValidation() {
    if (this.email) {
      const emailValue = this.email.value;
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const result = re.test(emailValue);

      return result && result !== "";
    } else {
      return true;
    }
  }

  phoneValidation() {
    if (this.phone) {
      const phoneValue = this.phone.value;
      const re = /^\+[1-9]\d{1,14}$/;
      const result = re.test(phoneValue);

      return result && result !== "";
    } else {
      return true;
    }
  }

  onPhoneInput() {
    let phoneInput = this.value;
    phoneInput = phoneInput.replace(/[^0-9+]/g, "");

    if (!phoneInput.startsWith("+1")) {
      phoneInput = "+1" + phoneInput.replace(/^\+?[0-9]*/, "");
    }
    this.value = phoneInput;
  }
}
